import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { StaffRoleFragmentDoc } from '../../fragments/generated/StaffRole';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type StaffRolesQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.RolesFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type StaffRolesQuery = { staffRoles?: { success: boolean, totalCount: number, errorCode?: Types.PaginationErrorCodeEnum | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, description?: string | null, type: Types.RoleTypesEnum, metadata?: { tagColor?: string | null, configuredPermissions?: Array<string> | null } | null } }> | null } | null };


export const StaffRolesDocument = /*#__PURE__*/ gql`
    query staffRoles($filters: RolesFilters, $sort: [SortType!], $first: Float, $after: String) {
  staffRoles(filters: $filters, sort: $sort, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    success
    totalCount
    errorCode
    edges {
      node {
        ...StaffRole
      }
    }
  }
}
    ${StaffRoleFragmentDoc}`;

export function useStaffRolesQuery(options?: Omit<Urql.UseQueryArgs<StaffRolesQueryVariables>, 'query'>) {
  return Urql.useQuery<StaffRolesQuery, StaffRolesQueryVariables>({ query: StaffRolesDocument, ...options });
};